module.exports = __webpack_public_path__ + "static/property-app-1-7b9dd2ba6af7e6656c0efcefb144361e.png";